import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { MpAdminService } from "../../../services/api/mp-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";
import { AppState } from "../../reducers";
import { MpAdminSelectors } from "../../selectors/mp-admin.selectors";

@Injectable()
export class AdminConsumerUsersEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.consumerUsers.get),
			withLatestFrom(this.store.select(MpAdminSelectors.consumerUsers)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(action, state)
					? of(MpAdminActions.consumerUsers.getSuccess(state))
					: of(MpAdminActions.consumerUsers.getApi({ params: action.params }))
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.consumerUsers.getApi),
			withLatestFrom(this.store.select(MpAdminSelectors.consumerUsers)),
			switchMap(([action, state]) =>
				this.mpAdminService.consumerUsers(action.params.id).pipe(
					map((users) => {
						return MpAdminActions.consumerUsers.getSuccess({ users, loading: false });
					}),
					catchError((error) => {
						return of(MpAdminActions.consumerUsers.getFail(new FailState(error)));
					})
				)
			)
		)
	);

	constructor(
		private mpAdminService: MpAdminService,
		private actions: Actions,
		private store: Store<AppState>
	) {}

	private canUseStoreValue(action, state: any): boolean {
		const ids = _.split(_.get(action, "params.id", "noop"), ",");
		const storeIds = _.map(state.consumerUsers, (c) => c.id);
		const idPresent = _.every(ids, (id) => _.includes(storeIds, id));
		return idPresent && !_.has(state, "error") && !state.loading;
	}
}
